import {remCalc} from '_themeUtils'

export default {
    '.swiper-button-next,.swiper-button-prev': {
        position: 'absolute',
        top: '50%',
        width: 'calc(44px / 44 * 27)',
        height: remCalc(44),
        marginTop: 'calc(0px - (44px / 2))',
        zIndex: 10,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'black',
    },
    '.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled': {
        opacity: 0.35,
        cursor: 'auto',
        pointerEvents: 'none',
    },
    '.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden': {
        opacity: 0,
        cursor: 'auto',
        pointerEvents: 'none',
    },
    '.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev': {
        display: 'none !important',
    },
    '.swiper-button-next svg,.swiper-button-prev svg': {
        // width: '100%',
        // height: '100%',
        objectFit: 'contain',
        transformOrigin: 'center',
    },
    '.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg': {
        transform: 'rotate(180deg)',
    },
    '.swiper-button-prev,.swiper-rtl .swiper-button-next': {
        left: remCalc(10),
        right: 'auto',
    },
    '.swiper-button-next,.swiper-rtl .swiper-button-prev': {
        right: remCalc(10),
        left: 'auto',
    },
    '.swiper-button-prev.swiper-button-lock, .swiper-button-next.swiper-button-lock': {display: 'none'},
    '.swiper-button-next:after,.swiper-button-prev:after': {
        fontFamily: 'swiper-icons',
        fontSize: remCalc(44),
        textTransform: 'none !important',
        letterSpacing: '0',
        fontVariant: 'initial',
        lineHeight: 1,
    },
    '.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after': {
        content: "'prev'",
    },
    '.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after': {
        content: "'next'",
    },
}
